<template>
  <span>
    {{ claimReference || 'Not Provided' }}
  </span>
</template>

<script>
export default {
  props: {
    job: {
      type: Object,
      required: true
    }
  },

  computed: {
    claimReference() {
      if (this.job.jobable?.source) {
        return this.job.jobable.source.claim_reference;
      }

      if (this.job.jobable?.incident) {
        return this.job.jobable.incident.source?.claim_reference;
      }

      return '';
    }
  }
};
</script>
